var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdcInfoHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1878_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7293 3.91382C33.4303 3.94958 31.1814 4.59135 29.2098 5.77433C27.2381 6.95731 25.6136 8.6396 24.5001 10.6513C23.3867 8.6396 21.7621 6.95731 19.7905 5.77433C17.8188 4.59135 15.57 3.94958 13.271 3.91382C9.60604 4.07305 6.1531 5.6763 3.66651 8.37329C1.17991 11.0703 -0.138206 14.6418 0.000118295 18.3076C0.000118295 27.591 9.77153 37.7299 17.9668 44.6042C19.7966 46.1419 22.1101 46.9849 24.5001 46.9849C26.8902 46.9849 29.2037 46.1419 31.0335 44.6042C39.2287 37.7299 49.0001 27.591 49.0001 18.3076C49.1384 14.6418 47.8203 11.0703 45.3337 8.37329C42.8471 5.6763 39.3942 4.07305 35.7293 3.91382ZM28.4099 41.4805C27.3155 42.402 25.9308 42.9074 24.5001 42.9074C23.0694 42.9074 21.6847 42.402 20.5903 41.4805C10.1002 32.6789 4.08345 24.2345 4.08345 18.3076C3.94388 15.7243 4.83145 13.1906 6.55257 11.2591C8.27369 9.32764 10.6887 8.15508 13.271 7.99715C15.8532 8.15508 18.2682 9.32764 19.9893 11.2591C21.7105 13.1906 22.598 15.7243 22.4585 18.3076C22.4585 18.8491 22.6736 19.3684 23.0564 19.7512C23.4393 20.1341 23.9586 20.3492 24.5001 20.3492C25.0416 20.3492 25.5609 20.1341 25.9438 19.7512C26.3267 19.3684 26.5418 18.8491 26.5418 18.3076C26.4022 15.7243 27.2898 13.1906 29.0109 11.2591C30.732 9.32764 33.1471 8.15508 35.7293 7.99715C38.3115 8.15508 40.7265 9.32764 42.4477 11.2591C44.1688 13.1906 45.0564 15.7243 44.9168 18.3076C44.9168 24.2345 38.9 32.6789 28.4099 41.4723V41.4805Z",
    fill: "#1D1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1878_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdcInfoHeart);
export default __webpack_public_path__ + "static/media/edc-info-heart.e0a07b05de84934649d3df2c11f8bb22.svg";
export { ForwardRef as ReactComponent };